export default {
  // Tiêu đề trang
  title: "Quản lý hộp thư",
  stationLetter: "Tin nhắn nội bộ",
  autoConfig: "Cấu hình gửi tự động",
  autoConfigMessage: "Lịch sử gửi tự động",

  // Biểu mẫu tìm kiếm
  recipient: "Tài khoản thành viên",
  recipientPlaceholder: "Nhập tài khoản thành viên",
  subject: "Chủ đề",
  subjectPlaceholder: "Nhập chủ đề",
  status: "Trạng thái",
  statusPlaceholder: "Chọn trạng thái",
  sendTime: "Thời gian vận hành",
  statisticsDate: "Ngày thống kê",
  search: "Tìm kiếm",
  reset: "Đặt lại",
  export: "Xuất",

  // Trạng thái
  unread: "Chưa đọc",
  read: "Đã đọc",
  deleted: "Đã xóa",
  
  // Trạng thái nhiệm vụ
  taskStatus: "Trạng thái nhiệm vụ",
  statusNotSent: "Chưa gửi",
  statusSending: "Đang gửi",
  statusSent: "Đã gửi",
  
  // Thao tác
  operationTime: "Thời gian thao tác",
  operator: "Người vận hành",
  agentMembers: "Thành viên đại lý",
  startTime: "Thời gian bắt đầu",
  endTime: "Thời gian kết thúc",
  memberType: "Loại thành viên",

  // Tiêu đề cột bảng
  content: "Nội dung",
  language: "Ngôn ngữ",
  receiveTime: "Thời gian nhận",
  sender: "Người vận hành",
  messageType: "Loại tin nhắn",

  // Thông báo
  exporting: "Đang xuất...",
  exportSuccess: "Xuất thành công",
  exportFailed: "Xuất thất bại",
  operationFailed: "Thao tác thất bại",
  requestFailed: "Yêu cầu thất bại",

  // Khác
  seeDetails: "Xem",

  // Gửi modal hộp thư
  sendMessage: "Gửi tin nhắn nội bộ",
  language_label: "Chọn ngôn ngữ:",
  recipient_label: "Tài khoản thành viên:",
  designatedMembers: "Thành viên được chỉ định",
  allMembers: "Tất cả thành viên",
  agent: "Đại lý cấp dưới",
  designatedVipMembers: "Thành viên VIP được chỉ định",
  directCustomers: "Khách hàng trực tiếp",
  importUsernames: "Nhập tên người dùng",
  agentLabel: "Đại lý:",
  selectAgent: "Chọn đại lý",
  vipLevelLabel: "Cấp VIP:",
  selectVipLevel: "Chọn cấp VIP",
  membersLabel: "Chọn thành viên:",
  memberPlaceholder: "Tìm kiếm và chọn thành viên",
  membersRequired: "Vui lòng chọn thành viên",
  usernamesLabel: "Nhập tên người dùng:",
  usernamesPlaceholder: "Nhập tên người dùng, nhiều người dùng cách nhau bằng dấu phẩy hoặc dòng mới",
  usernamesRequired: "Vui lòng nhập hoặc nhập tên người dùng",
  titleLabel: "Chủ đề:",
  titlePlaceholder: "Trong 50 ký tự",
  titleRequired: "Vui lòng nhập chủ đề",
  summaryLabel: "Tóm tắt",
  summaryPlaceholder: "Nhập tóm tắt, tối đa 200 ký tự",
  coverImageLabel: "Ảnh bìa",
  titleMaxLength: "Chủ đề không được vượt quá 50 ký tự",
  contentLabel: "Nội dung:",
  contentRequired: "Vui lòng nhập nội dung",
  contentMaxLength: "Nội dung không được vượt quá 1000 ký tự",
  contentCharLimit: "Giới hạn ký tự nội dung: 1000",
  sendSuccess: "Gửi thành công",
  sendFailed: "Gửi thất bại",

  // Tùy chọn trạng thái
  statusUnread: "Chưa đọc",
  statusRead: "Đã đọc",
  statusDeleted: "Đã xóa",

  // Đếm người dùng mục tiêu
  targetUsers: "Người dùng mục tiêu",
  downloadTemplate: "Tải xuống mẫu",

  // Loại tin nhắn
  messageType_label: "Loại tin nhắn:",
  messageType_system: "Tin nhắn hệ thống",
  messageType_promos: "Tin nhắn khuyến mãi",
  messageType_updates: "Tin nhắn nền tảng",

  // Cấu hình gửi tự động
  autoConfigTitle: "Thêm mẫu gửi tự động",
  autoConfigTitle_edit: "Chỉnh sửa mẫu gửi tự động",
  templateCode_label: "Loại mục tiêu:",
  templateCode_placeholder: "Chọn loại mục tiêu",
  templateCode_required: "Vui lòng chọn loại mục tiêu",
  registerUsers: "Người dùng mới đăng ký",
  firstRechargeUsers: "Người dùng nạp lần đầu",
  title_label: "Tiêu đề:",
  title_placeholder: "Trong 50 ký tự",
  title_required: "Vui lòng nhập tiêu đề",
  title_maxLength: "Tiêu đề mẫu không được vượt quá 50 ký tự",
  recipient_type_label: "Tài khoản thành viên:",
  allMembers_label: "Tất cả thành viên",
  agent_label: "Đại lý",
  agent_select_label: "Đại lý:",
  agent_placeholder: "Chọn đại lý",
  agent_required: "Vui lòng chọn đại lý",
  messageType_type_label: "Loại tin nhắn:",
  messageType_placeholder: "Chọn loại tin nhắn",
  messageType_required: "Vui lòng chọn loại tin nhắn",
  content_label: "Nội dung:",
  content_required: "Vui lòng nhập nội dung",
  content_maxLength: "Nội dung không được vượt quá 1000 ký tự",
  autoConfig_search: "Tìm kiếm",
  autoConfig_reset: "Đặt lại",
  autoConfig_add: "Thêm",
  autoConfig_edit: "Chỉnh sửa",
  autoConfig_enable: "Kích hoạt",
  autoConfig_delete: "Xóa",
  autoConfig_templateName: "Tiêu đề mẫu",
  autoConfig_targetType: "Loại mục tiêu",
  autoConfig_status: "Trạng thái",
  autoConfig_language: "Ngôn ngữ",
  autoConfig_content: "Nội dung",
  autoConfig_operator: "Người vận hành",
  autoConfig_actions: "Hành động",
  autoConfig_disabled: "Vô hiệu hóa",
  autoConfig_enabled: "Kích hoạt",
  autoConfig_disable: "Vô hiệu hóa",
  autoConfig_all: "Tất cả",
  autoConfig_enableSuccess: "Kích hoạt thành công",
  autoConfig_disableSuccess: "Vô hiệu hóa thành công",
  autoConfig_deleteSuccess: "Xóa thành công",
  autoConfig_deleteFailed: "Xóa thất bại",
  autoConfig_operationFailed: "Thao tác thất bại",
  autoConfig_editSuccess: "Cập nhật thành công",
  autoConfig_editFailed: "Cập nhật thất bại",
  autoConfig_createSuccess: "Tạo thành công",
  autoConfig_createFailed: "Tạo thất bại",
  
  // Placeholder related
  placeholder_availablePlaceholders: "Chỗ dành sẵn có sẵn",
  placeholder_noPlaceholders: "Không có chỗ dành sẵn",
  placeholder_example: "Ví dụ",
  placeholder_insertToTitle: "Chèn vào tiêu đề",
  placeholder_insertToContent: "Chèn vào nội dung",
  placeholder_tip: "Mẹo: Nhấp vào chỗ dành sẵn để sao chép, di chuột để xem chi tiết và tùy chọn chèn",
  placeholder_copied: "Đã sao chép vào clipboard",
  placeholder_copyFailed: "Sao chép thất bại",
  placeholder: {
    memberAccount_desc: "Tài khoản thành viên",
    currency_desc: "Tiền tệ"
  },
  
  // Trang thống kê
  stats_serialNumber: "Số thứ tự",
  stats_targetType: "Loại mục tiêu",
  stats_memberType: "Loại thành viên",
  stats_statisticsTime: "Thời gian thống kê",
  stats_received: "Đã nhận",
  stats_readCount: "Số đã đọc",
  stats_unreadCount: "Số chưa đọc",
  stats_readRate: "Tỷ lệ đọc",
  startDate: "Ngày bắt đầu",
  endDate: "Ngày kết thúc"
};
